// material-ui

import changesstatustripicon from '../../../assets/images/changes-status-of-trip.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const ChangesStatusTripIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={changesstatustripicon} alt="Changes Status of Trip" width="22"  />
    );
};

export default ChangesStatusTripIcon;
